export default __webpack_public_path__ + "static/media/component-menu.34639dbb.png";